import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import { useLanguageContext } from "../../../../context/LanguageContext";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../../../styles/CardStyles";
import {
  StyledFlexColumn,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import { faDoorOpen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Select from "../../../../components/select/main/Select";
import { useAuthContext } from "../../../../context/AuthContext";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import { useTheme } from "styled-components";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import HiddenLoader from "../../../../components/loader/HiddenLoader/HiddenLoader";

function SaltoLocksView({
  configData,
  availableLocks = [],
  lockLabels = {},
  onLockAdd,
  onLockLocationChange,
  onLockEntryTypeChange,
  onLockDelete,
  onLockOpen,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();
  const authContext = useAuthContext();

  return (
    <OverlayLoader groups="salto_configs_page_fetch">
      <StyledCard>
        <StyledCardHeader>
          <StyledFlexRow
            style={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 style={{ flex: 1 }}>{translate("eva.main.entities.locks")}</h2>

            <IconSelect
              options={availableLocks.map((lock) => ({
                value: lock.id,
                label: lock.label,
              }))}
              icon={() => <FontAwesomeIcon icon={faPlus} />}
              style={{ marginLeft: "auto" }}
              onChange={(value) => onLockAdd(value)}
              disabled={availableLocks.length <= 0}
            />
          </StyledFlexRow>
        </StyledCardHeader>

        <StyledCardBody>
          <StyledFlexColumn>
            {configData?.locks?.map((configLock) => (
              <StyledFlexRow
                key={configLock.lock_id}
                style={{
                  alignItems: "flex-end",
                  padding: theme.spacing.normal,
                  borderRadius: theme.radius.normal,
                  border: `1px solid ${theme.colors.primary.darkest}`,
                }}
              >
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.locks.*.lock_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configLock.lock_id}
                    options={[
                      {
                        value: configLock.lock_id,
                        label:
                          lockLabels[configLock.lock_id] || configLock.lock_id,
                      },
                    ]}
                    style={{ opacity: 1 }}
                    hideCaret={true}
                    disabled
                  />
                </InputWrapper>

                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.locks.*.location_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configLock.location_id}
                    options={authContext.auth?.user?.company?.locations?.map(
                      (location) => ({
                        value: location.id,
                        label: location.name,
                      }),
                    )}
                    onChange={(value) =>
                      onLockLocationChange(configLock.lock_id, value)
                    }
                  />
                </InputWrapper>

                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.locks.*.entry_type",
                  )}
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configLock.entry_type}
                    nullable
                    options={[
                      {
                        value: "entrance",
                        label: translate(
                          "eva.main.validation.values.locks.*.entry_type.entrance",
                        ),
                      },
                      {
                        value: "exit",
                        label: translate(
                          "eva.main.validation.values.locks.*.entry_type.exit",
                        ),
                      },
                      {
                        value: "entrance_exit",
                        label: translate(
                          "eva.main.validation.values.locks.*.entry_type.entrance_exit",
                        ),
                      },
                    ]}
                    onChange={(value) =>
                      onLockEntryTypeChange(configLock.lock_id, value)
                    }
                  />
                </InputWrapper>

                {configLock.id && (
                  <HiddenLoader
                    groups={`salto_lock_open_${configLock.lock_id}`}
                  >
                    <StyledAltIconButton
                      onClick={() => onLockOpen(configLock.lock_id)}
                    >
                      <FontAwesomeIcon icon={faDoorOpen} />
                    </StyledAltIconButton>
                  </HiddenLoader>
                )}

                <StyledAltIconButton
                  onClick={() => onLockDelete(configLock.lock_id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </StyledAltIconButton>
              </StyledFlexRow>
            ))}
          </StyledFlexColumn>
        </StyledCardBody>
      </StyledCard>
    </OverlayLoader>
  );
}

export default SaltoLocksView;
